import { render, staticRenderFns } from "./HomepageRecipent.vue?vue&type=template&id=62e558b6&scoped=true"
import script from "./HomepageRecipent.vue?vue&type=script&lang=js"
export * from "./HomepageRecipent.vue?vue&type=script&lang=js"
import style0 from "./HomepageRecipent.vue?vue&type=style&index=0&id=62e558b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e558b6",
  null
  
)

export default component.exports